import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from '../../../shared/services/service.service';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';
import { GetInServiceCarFaultsResponse, SetCarFaultFinishedRequest, SetUnfinishedCarFaultsToRegisteredRequest } from '../../../shared/models/service.models';
import { GetCommentResponse, PostEndVoucherRequest, GetOdometerValueResponse } from '../../../shared/models/courier.models';
import { CourierService } from '../../../shared/services/courier.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'service-voucher-finish.component.html',
  styleUrls: ['./service-voucher-finish.component.scss']
})
export class ServiceVoucherFinishComponent implements OnInit {
  odometerResponse: GetOdometerValueResponse | null = null;
  inServiceCarFaultsResponse: GetInServiceCarFaultsResponse | null = null;
  endOdometrValue: number = 0;
  endHours: number = 0;
  endMinutes: number = 0;
  choosedDate: Date = new Date();
  comment: string = '';
  hours = Array.from({ length: 24 }, (_, i) => ({ value: i }));
  minutes = Array.from({ length: 12 }, (_, i) => ({ value: i * 5 }));
  popupVisibleError = false;
  loading = true;
  isMobile: boolean = false;
  showPopup = false;
  popupMessage = '';

  constructor(
    private serviceService: ServiceService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private courierService: CourierService,
    private router: Router,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.checkIfMobile();
    this.initializeData();
  }

  @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      this.checkIfMobile();
    }
  
    private checkIfMobile() {
      this.isMobile = window.innerWidth <= 768;
    }

  async initializeData() {
    const carId = this.activeUserLocalDataService.activeServiceVoucher?.carsId;
    const voucherId = this.activeUserLocalDataService.activeServiceVoucherId;

    if (carId && voucherId) {
      this.odometerResponse = await this.courierService.getOdometrValue({ carId }).toPromise() ?? null;
      if (this.odometerResponse?.odometerValue) {
        this.endOdometrValue = this.odometerResponse.odometerValue.odometerEndVal ?? 0;
      }

      this.endHours = new Date().getHours();
      this.endMinutes = Math.round(new Date().getMinutes() / 5) * 5;

      this.inServiceCarFaultsResponse = await this.serviceService.getInServiceCarFaults({ carId }).toPromise() ?? null;
      if (this.inServiceCarFaultsResponse?.carFaults) {
        this.inServiceCarFaultsResponse.carFaults.forEach(fault => fault.isFixed = true);
      }

      const commentResponse: GetCommentResponse = await this.courierService.getComment({ voucherId }).toPromise() ?? { comment: [] };
      if (commentResponse.comment) {
        this.comment = commentResponse.comment.map(c => c.driverComment).join('\n');
      }
    }

    this.loading = false;
  }

  dayBack() {
    const changedDate = new Date(this.choosedDate);
    changedDate.setDate(changedDate.getDate() - 1);
    this.choosedDate = changedDate; 
  }
  
  dayForward() {
    const changedDate = new Date(this.choosedDate);
    changedDate.setDate(changedDate.getDate() + 1);
    this.choosedDate = changedDate; 
  }

  async endVoucher() {
    if (this.odometerResponse?.odometerValue) {
      const odometerDifference = this.endOdometrValue - (this.odometerResponse.odometerValue.odometerEndVal ?? 0);
  
      if (odometerDifference > 1500) {
        this.popupMessage = this.translateService.instant('EnteredOdometerVlueExceeds1500KmPleaseEnterAValidOdometerValue');
        this.showPopup = true;
        return;
      }
  
      const finalDate = new Date(this.choosedDate); 
    finalDate.setHours(this.endHours, this.endMinutes);
  
      await this.courierService.postEnd({
        odometerEndVal: this.endOdometrValue,
        voucherId: this.activeUserLocalDataService.activeServiceVoucherId,
        workEndTime: finalDate,
        driverComment: this.comment
      }).toPromise();
  
      if (this.inServiceCarFaultsResponse?.carFaults) {
        for (const fault of this.inServiceCarFaultsResponse.carFaults) {
          if (fault.isFixed) {
            await this.serviceService.setCarFaultFinished({
              carFaultId: fault.carFaultId,
              carId: this.activeUserLocalDataService.activeServiceVoucher?.carsId,
              voucherId: this.activeUserLocalDataService.activeServiceVoucherId
            }).toPromise();
          }
        }
      }
  
      await this.serviceService.setUnfinishedCarFaultsToRegistered({
        carId: this.activeUserLocalDataService.activeServiceVoucher?.carsId,
        voucherId: this.activeUserLocalDataService.activeServiceVoucherId
      }).toPromise();
  
      this.activeUserLocalDataService.activeServiceVoucherId = undefined;
      this.activeUserLocalDataService.activeServiceCarNumber = '';
      this.router.navigate(['/service-voucher']);
    } else {
      this.popupMessage = this.translateService.instant('PleaseEnterAValidOdometerValue');
      this.showPopup = true;
    }
  }

  navigateBack() {
    this.router.navigate(['/service']);
  }

  closePopup() {
    this.showPopup = false;
  }
}